module.exports = __webpack_public_path__ + "static/media/991939.342c2163.png";